import CaptchaRule from "./captcha.rule";
import PowRule from "./pow.rule";
import CsrfRule from "./csrf.rule";


export default {
    'pow': PowRule,
    'captcha': CaptchaRule,
    'csrf': CsrfRule,
}
